import type { BaseApiResponse } from './types/api.types';

import { get } from './axios';

export const fetchWorkoutProgressById = async ({
  workoutId,
}: {
  workoutId: string;
}) => {
  const response = await get<BaseApiResponse<any>>(`/v2/progress/${workoutId}`);
  if (!response?.data) return null;
  return response.data;
};
